class ProductInfoDialogTrigger extends HTMLElement {
  #listeners;

  connectedCallback() {
    this.#listeners?.abort();
    this.#listeners = new AbortController();
    const { signal } = this.#listeners;
    this.addEventListener('click', this.#open, { signal });
    this.addEventListener('keydown', this.#onKeydown, { signal });
  }

  disconnectedCallback() {
    this.#listeners?.abort();
  }

  #onKeydown = (event) => {
    if (event.target !== this || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    this.#open();
  };

  #open = () => {
    const template = this.querySelector('[data-dialog-content]');
    const dialog = document.getElementById('product-info-dialog');
    const body = dialog?.querySelector('.dialog-body-box');
    const title = dialog?.querySelector('.dialog-title-text');
    if (!(template instanceof HTMLTemplateElement) || !body || !title) return;

    // This is trusted server-rendered HTML. innerHTML preserves the old dialog contract: embedded scripts stay inert.
    body.innerHTML = template.innerHTML;
    const label = this.dataset.dialogTitle;
    if (label?.trim()) title.textContent = label;
    dialog.setAttribute('open', '');
  };
}

if (!customElements.get('product-info-dialog-trigger')) {
  customElements.define('product-info-dialog-trigger', ProductInfoDialogTrigger);
}
